import type { SurveyFilters } from 'app/common/types/surveys'
import PlainItemsSelector from 'app/common/ui-next/plain-selector/plain-items-selector'
import { sortByTitle } from 'app/common/lib/sort'

import type { SurveyFilterItemProps } from './types'


export const SchoolTypeFilter = ({
  value,
  options,
  loading,
  multiple,
  colorInverse,
  disabled,
  onChange,
}: SurveyFilterItemProps) => {
  const handleChange = (schoolTypes: Array<string>) => {
    onChange({
      ...value,
      schoolTypes: schoolTypes as SurveyFilters['schoolTypes'],
      cityIds: [],
      districtIds: [],
      schoolIds: [],
    })
  }

  return (
    <PlainItemsSelector
      id="surveySchoolType"
      label="Тип заведения"
      header="Выбор типа заведения"
      sortFunc={sortByTitle}
      selection={value.schoolTypes}
      items={options.schoolTypes}
      multiple={multiple}
      colorInverse={colorInverse}
      disabled={loading || disabled}
      onChange={handleChange}
      selectedAllOnEmptySelection
      skipUpperSpace
      disableAutoSelect
      doOnBadgeCrossClick="clear"
      maxViewCountBadge={3}
    />
  )
}
